import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import styled, { css } from 'styled-components'
import { mapLanguageToComponentProps } from 'i18n'
import { H3 } from 'components/styled/typography'

function getTextQuestionClassName(children) {
  if (typeof children === 'string') {
    if (children.length >= 300) {
      return 'length-300'
    }
    if (children.length >= 200) {
      return 'length-200'
    }
    return ''
  }
  return ''
}


const LengthStyle = css`
  font-size: ${({ theme, $lengthClass }) => {
    if ($lengthClass === 'length-300') {
      return theme.space.s14
    }
    if ($lengthClass === 'length-200') {
      return theme.space.s16
    }
    return theme.space.s20
  }};

  ${({ theme }) => theme.mediaQuery.smallPhone} {
    font-size: ${({ theme, $lengthClass }) => {
      if ($lengthClass === 'length-300') {
        return theme.space.s12
      }
      if ($lengthClass === 'length-200') {
        return theme.space.s14
      }
      return theme.space.s20
    }};
  }
`

const ContainerPaddingStyle = css`
  padding: ${({ theme }) => theme.space.s16};

  ${({ theme }) => theme.mediaQuery.phone} {
    font-size: ${({ theme, $lengthClass }) => {
      if ($lengthClass === 'length-300') {
        return theme.space.s4
      }
      if ($lengthClass === 'length-200') {
        return theme.space.s12
      }
      return theme.space.s16
    }};
  }
`

const TextContainer = styled.div`
  ${ContainerPaddingStyle};
`

const StyledH3 = styled(H3)`
  ${LengthStyle};
`

const RelativeContainer = styled.div`
  position: relative;
  width: 100%;
  height: 0;
  padding-top: 75%;
`

const AbsoluteContainer = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  row-gap: ${({ theme }) => theme.space.s16};
  justify-content: center;
  align-items: center;
`

const StyledTextQuestion = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  word-break: break-word;
  word-wrap: break-word;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme }) => theme.color.grey30};
  border-radius: ${props => !props.$editMode && props.theme.space.s12};
`
export function TextQuestion({ children, editMode }) {
  const className = getTextQuestionClassName(children)

  return (
    <RelativeContainer>
      <AbsoluteContainer>
        <StyledTextQuestion $editMode={editMode} className="text-question">
          <TextContainer $lengthClass={className}>
            {typeof children === 'string' ? (
              <StyledH3
                fontWeight={300}
                color="bodyText"
                $lengthClass={className}
              >
                {children}
              </StyledH3>
            ) : (
              <span>{children}</span>
            )}
          </TextContainer>
        </StyledTextQuestion>
      </AbsoluteContainer>
    </RelativeContainer>
  )
}

TextQuestion.propTypes = {
  editMode: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
}

TextQuestion.defaultProps = {
  children: undefined,
  editMode: false,
}

export default connect(mapLanguageToComponentProps())(TextQuestion)
